import ReportService from "../../../services/ReportService";
class SIFilter {
  async getSIReport() {
    try {
      const response = await ReportService.getSIReport();
      return response.result;
    } catch (error) {
      throw error;
    }
  }

  async getGatewayWiseReport() {
    try {
      const response = await ReportService.getGatewayWiseReport();
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getGatewayWiseSNReport(serialNumber) {
    try {
      const response = await ReportService.getGatewayWiseSNReport(serialNumber);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getGatewaysbySNReport(serialNumber) {
    try {
      const response = await ReportService.getGatewaysbySNReport(serialNumber);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getSIWiseReport() {
    try {
      const response = await ReportService.getSIWiseReport();
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getSearchbySNReport(fname, lname) {
    try {
      const response = await ReportService.getSearchbySNReport(fname, lname);
      return response;
    } catch (error) {
      throw error;
    }
  }
}
const siFilter = new SIFilter();
export default siFilter;
